// src/components/admin/AdminSettings.jsx
import React, { useState } from 'react';
import PayrollRules from './PayrollRules';
import PolicyManagement from './PolicyManagement';

/* ─── tab definitions ────────────────────────────────────────────────────── */
const TABS = [
  {
    id:    'payroll',
    label: '⚙ Payroll Rules',
    desc:  'Late penalties, salary divisor, overtime',
    color: '#4f46e5',
    bg:    '#ede9fe',
  },
  {
    id:    'attendance',
    label: '🕐 Attendance Policies',
    desc:  'Grace periods, minimum hours, punch requirements',
    color: '#0284c7',
    bg:    '#e0f2fe',
  },
  {
    id:    'leave',
    label: '🌿 Leave Policies',
    desc:  'Carry-forward, encashment, auto-approve',
    color: '#059669',
    bg:    '#d1fae5',
  },
  {
    id:    'general',
    label: '🏛 General Settings',
    desc:  'Institution name, currency, session timeout',
    color: '#d97706',
    bg:    '#fef3c7',
  },
];

/* ─── styles ─────────────────────────────────────────────────────────────── */
const S = {
  wrap: {
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    padding: 24,
  },
  heading: {
    fontSize: 22, fontWeight: 700, color: '#0f172a', margin: '0 0 4px',
  },
  sub: {
    fontSize: 13, color: '#64748b', margin: '0 0 28px',
  },
  tabGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(210px, 1fr))',
    gap: 14,
    marginBottom: 28,
  },
  tabCard: (active, color, bg) => ({
    padding: '14px 16px',
    borderRadius: 12,
    border: `2px solid ${active ? color : '#e2e8f0'}`,
    background: active ? bg : '#fff',
    cursor: 'pointer',
    transition: 'all .15s',
    boxShadow: active ? `0 0 0 3px ${color}22` : '0 1px 3px #0001',
  }),
  tabLabel: (active, color) => ({
    fontSize: 14, fontWeight: 700,
    color: active ? color : '#334155',
    display: 'block', marginBottom: 4,
  }),
  tabDesc: {
    fontSize: 12, color: '#94a3b8', lineHeight: 1.4,
  },
  divider: {
    borderTop: '1px solid #e2e8f0', marginBottom: 24,
  },
};

/* ─── component ──────────────────────────────────────────────────────────── */
export default function AdminSettings() {
  const [activeTab, setActiveTab] = useState('payroll');

  return (
    <div style={S.wrap}>
      <h2 style={S.heading}>System Settings</h2>
      <p style={S.sub}>
        Configure business rules that govern payroll, attendance, and leave — all changes
        apply immediately without any code deployment.
      </p>

      {/* Tab selector */}
      <div style={S.tabGrid}>
        {TABS.map(t => (
          <div
            key={t.id}
            style={S.tabCard(activeTab === t.id, t.color, t.bg)}
            onClick={() => setActiveTab(t.id)}
          >
            <span style={S.tabLabel(activeTab === t.id, t.color)}>{t.label}</span>
            <span style={S.tabDesc}>{t.desc}</span>
          </div>
        ))}
      </div>

      <div style={S.divider} />

      {/* Special view for payroll (has its own richer UI) */}
      {activeTab === 'payroll' && <PayrollRules />}

      {/* All other categories use the generic PolicyManagement component */}
      {activeTab !== 'payroll' && (
        <PolicyManagement
          category={activeTab.toUpperCase()}
          categoryLabel={TABS.find(t => t.id === activeTab)?.label || activeTab}
        />
      )}
    </div>
  );
}